module.exports = __webpack_public_path__ + "static/media/Montserrat-Bold.a79b68fc.woff";